module.exports = {
  'cap': false,
  'curry': false,
  'fixed': false,
  'immutable': false,
  'rearg': false
};



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/~/lodash/fp/_falseOptions.js
 **/